import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GenericTreeExpansionService {
  private readonly STORAGE_PREFIX = 'generic-tree-expansion-';
  private cache = new Map<string, Set<string>>();

  isExpanded(nodeId: string, consumerId: string, subjectId: string): boolean {
    const key = this.getKey(consumerId, subjectId);
    const expandedNodes = this.getExpandedNodesSet(key);
    return expandedNodes.has(nodeId);
  }

  setExpanded(nodeId: string, consumerId: string, subjectId: string, isExpanded: boolean): void {
    const key = this.getKey(consumerId, subjectId);
    const expandedNodes = this.getExpandedNodesSet(key);

    if (isExpanded) {
      expandedNodes.add(nodeId);
    }
    else {
      expandedNodes.delete(nodeId);
    }

    this.saveExpandedNodesSet(key, expandedNodes);
  }

  private getKey(consumerId: string, subjectId: string): string {
    return `${this.STORAGE_PREFIX}${consumerId}-${subjectId}`;
  }

  private getExpandedNodesSet(key: string): Set<string> {
    if (this.cache.has(key)) {
      return this.cache.get(key)!;
    }

    const stored = localStorage.getItem(key);
    let nodes = new Set<string>();

    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        if (Array.isArray(parsed)) {
          nodes = new Set(parsed);
        }
      }
      catch (e) {
        console.warn('Failed to parse generic tree expansion state', e);
      }
    }

    this.cache.set(key, nodes);
    return nodes;
  }

  private saveExpandedNodesSet(key: string, nodes: Set<string>): void {
    this.cache.set(key, nodes);
    localStorage.setItem(key, JSON.stringify(Array.from(nodes)));
  }
}
